import React, { useEffect, useState } from 'react'
import { useTranslation } from '~/common/hooks/useTranslation'
import BodyCommon from '~/components/shared-components/BodyCommon'
import Datatable from '~/components/shared-components/Datatable'
import { useQueryState } from '~/common/hooks/useQueryState'
import { useCommon } from '~/views/redux/hooks/useCommon'
import { fromWei, getAssetType, is1155 } from '~/blockchain/provider'
import {
  convertAddressToProperFormat,
  formatAddress,
  formatNumber,
  formatTransaction,
} from '~/helpers/common'
import { Button, Col, Drawer, Row, Spin, Switch, Alert } from 'antd'
import configs from '~/configs'
import { FilterHistory } from '~/views/app/Profile/4TradeHistory/filterHistory'
import { getNameItemByContract, getNameItem, getNameItemV1 } from '~/helpers/ItemName'
import { useTheme } from '~/common/theme/redux/hooks/useTheme'
import { useMediaQuery } from 'react-responsive'
import {
  DATE_TIMEFORMAT_YYYY_MM_dd_HH_mm2,
  SCREEN_SIZE,
  getRankbyValue,
  getMaxParameter,
} from '~/common/constants'
import { FilterOutlined } from '@ant-design/icons'
import moment from 'moment'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { getSpeciesValue } from '~/helpers/Species'
import getImageHash from '~/assets/data/ImageHash.json'
import {convertImageFamrOfMonster, getImgByFarmTerrain} from '~/helpers/getValueByFarmTerrain'

export const TradeHistory = () => {
  const { t } = useTranslation()
  dayjs.extend(utc)
  dayjs.extend(timezone)
  const { page, pageSize, setPage, setPageSize } = useQueryState()
  const userTimezone = dayjs.tz.guess() // Lấy múi giờ local của user
  const userUtcOffset = dayjs().tz(userTimezone).utcOffset() / 60 // Lấy offset theo giờ
  const {
    data: { user },
  } = useTheme()
  const {
    actions: actionsCommon,
    data: { isLoading },
  } = useCommon()
  const [dataHistories, setDataHistories] = useState([])
  const [totalData, setTotalData] = useState(0)

  const [event, setEvent] = useState([])
  const [assetType, setAssetType] = useState([])
  const [date, setDate] = useState([null, null])
  const [isMyHistoryOnly, setIsMyHistoryOnly] = useState(false) 

  useEffect(() => {
    let dataTemp = {
      page: page,
      pageSize: pageSize,
      fromTime: isNaN(date[0]) ? undefined : date[0],
      toTime: isNaN(date[1]) ? undefined : date[1],
      event: event,
      addressContract: assetType,
    }

    if (isMyHistoryOnly && user) {
      dataTemp.address = user?.address_wallet
      actionsCommon.getHistories(dataTemp, async (res) => {
        let data = await Promise.all(
          res.data.map((temp, index) => {
            return {
              key: index,
              event:
                temp?.type === 'OrderCreated'
                  ? 'For Sale'
                  : temp?.type === 'OrderSuccessful'
                  ? user?.player_language === 'ja'
                    ? '買う'
                    : 'Buy'
                  : undefined,
              assetType: getAssetType(temp?.asset_address),
              tokenID: {
                id: temp?.tokenId,
                address: temp?.asset_address,
                name: temp?.tokenName,
                extra: temp?.tokenExtra,
                orderId: temp?.params[0],
                from: temp?.from,
              },
              time: temp?.timestamp,
              from: temp?.from,
              to: temp?.to,
              price: fromWei(temp?.priceInWei),
              txHash: temp?.transactionHash,
              created_at: temp?.timestamp,
              quantity: temp?.amount,
            }
          }),
        )
        setTotalData(res?.total)
        setDataHistories(data)
      })
    } else {
      actionsCommon.getAllHistories(dataTemp, async (res) => {
        let data = await Promise.all(
          res.data.map((temp, index) => {
            return {
              key: index,
              event:
                temp?.type === 'OrderCreated'
                  ? 'For Sale'
                  : temp?.type === 'OrderSuccessful'
                  ? user?.player_language === 'ja'
                    ? '買う'
                    : 'Buy'
                  : undefined,
              assetType: getAssetType(temp?.asset_address),
              tokenID: {
                id: temp?.tokenId,
                address: temp?.asset_address,
                name: temp?.tokenName,
                extra: temp?.tokenExtra,
                orderId: temp?.params[0],
                from: temp?.from,
              },
              time: temp?.timestamp,
              from: temp?.from,
              to: temp?.to,
              price: fromWei(temp?.priceInWei),
              txHash: temp?.transactionHash,
              created_at: temp?.timestamp,
              quantity: temp?.amount,
            }
          }),
        )
        setTotalData(res?.total)
        setDataHistories(data)
      })
    }
  }, [page, pageSize, date, event, assetType, isMyHistoryOnly, user])

  function getItemGraphic(itemId) {
      if (itemId === 'UPA 1912') {
        itemId = 'UPA_1912'
      }
      if (itemId === 'UPA Gorem') {
        itemId = 'UPA_Gorem'
      }
      if (itemId === 'UPA AC') {
        itemId = 'UPA_AC'
      }
      if (itemId === 'UPA ODEN') {
        itemId = 'UPA_ODEN'
      }
      if (itemId === 'UPA Ossan') {
        itemId = 'UPA_Ossan'
      }
      if (itemId === 'UPA Villain') {
        itemId = 'UPA_Villain'
      }
      if (itemId === 'Yamato T Shirt') {
        itemId = 'YamatoT_Shirt'
      }
      if (itemId === 'Sound Horse') {
        itemId = 'Soundhorse'
      }
      let formattedItemId = itemId?.replace(/\s+/g, '')
      for (let i = 0; i < getImageHash.length; i++) {
        let formattedImageHashItemId = getImageHash[i].itemId.replace(/\s+/g, '')

        if (formattedImageHashItemId === formattedItemId) {
          return getImageHash[i].itemGraphic
        }
      }
      return null
  }

  const converTextEvent = (text) => {
    switch (text) {
      case 'For Sale':
        return '出品'
      case '買う':
        return '購入'
      default:
        return ''
    }
  }

  const converTextassetType = (text) => {
    switch (text) {
      case 'Monster':
        return 'Monster'
      case 'Farm':
        return 'Farm'
      case 'Genesis Hash':
        return 'Genesis Hash'
      case 'General Hash':
        return 'General Hash'
      case 'Regeneration Hash':
        return 'Regeneration Hash'
      case 'Enhance Item':
        return '強化アイテム'
      case 'Training Item':
        return '育成アイテム'
      case 'Fusion Item':
        return '融合アイテム'
      default:
        return ''
    }
  }

  const columns = [
    {
      title: t('profile.tradeHistory.event'),
      dataIndex: 'event',
      align: 'center',
      key: 'event',
      render: (data) => {
        return (
          <div>
            {user?.player_language === 'ja' ? converTextEvent(data) : data}
          </div>
        )
      },
    },
    {
      title: t('profile.tradeHistory.assetType'),
      dataIndex: 'assetType',
      align: 'center',
      key: 'assetType',
      render: (data) => {
        return (
          <div>
            {user?.player_language === 'ja' ? converTextassetType(data) : data}
          </div>
        )
      },
    },
    {
      title: t('profile.tradeHistory.tokenImage'),
      dataIndex: 'tokenID',
      align: 'center',
      key: 'tokenID',
      render: (data) => {
        let imageUrl;
        if (is1155(data?.address)) {
          if (data?.address === process.env.REACT_APP_ADDRESS_TRAINING_ITEM) {
            imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/items/${getNameItemV1(0, data?.id)?.image}.png`;
          } else if (data?.address === process.env.REACT_APP_ADDRESS_ENHANCE_ITEM) {
            imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/items/${getNameItemV1(1, data?.id)?.image}.png`;
          } else if (data?.address === process.env.REACT_APP_ADDRESS_FUSION_ITEM) {
            imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/items/${getNameItemV1(2, data?.id)?.image}.png`;
          } else if (data?.address === process.env.REACT_APP_ADDRESS_REGENERATION_ITEM) {
            if (data?.name === 'Regeneration Hash [Random]') {
              imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/hash/Regeneration_Hash_Random.png`;
            } else if (data?.id >= 10000) {
              imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/hash/${getItemGraphic(data?.name)}`;
            } else {
              imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/items/${getNameItemV1(3, data?.id)?.image}.png`;
            }
          }
          return <div style={{ display: 'flex', justifyContent: 'center' , alignItems: 'center'}}><img src={imageUrl} alt={data?.name || 'Item'} style={{ width: 50, height: 50, objectFit: 'contain' }} /></div>;
        } else if (data?.address === process.env.REACT_APP_ADDRESS_CRYSTAL_ITEM) {
            const rank = getRankbyValue(data?.extra?.rank);
            const imageUrl = `/imgs/crystal/${rank}_${data?.extra?.maxParam}.svg`;
            return <div style={{ display: 'flex', justifyContent: 'center' , alignItems: 'center'}}><img src={imageUrl} alt={data?.name || 'Item'} style={{ width: 50, height: 50, objectFit: 'contain' }} /></div>;
        } else {
          if (typeof data?.name === 'string') {
            if (data?.address === process.env.REACT_APP_ADDRESS_MONSTER) {
              imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/gif/${data?.extra}.gif`;
            } else if (data?.address === process.env.REACT_APP_ADDRESS_FARM) {
              imageUrl = `/imgs/farm/${getImgByFarmTerrain(Number(data?.extra))}.png`
            }
          } else if (typeof data?.name === 'number') {
            imageUrl = `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/hash/${getSpeciesValue(data?.name, data?.extra)?.image}.png`
          }
          return <div style={{ display: 'flex', justifyContent: 'center' , alignItems: 'center'}}><img src={imageUrl} alt={data?.name || 'Item'} style={{ width: 50, height: 50, objectFit: 'contain' }} /></div>;
        }
      },
    },
    {
      title: t('profile.tradeHistory.tokenID'),
      dataIndex: 'tokenID',
      align: 'center',
      key: 'tokenID',
      render: (data) => {
        let link;
        if (is1155(data?.address)) {
          if (data?.address === process.env.REACT_APP_ADDRESS_TRAINING_ITEM) {
            link = `${process.env.REACT_APP_BASE_URL_MARKET}/item-detail/${getNameItemV1(0, data?.id)?.id}/${data?.from}/${data?.orderId}/${data?.id}/Training_Item/1`;
          } else if (data?.address === process.env.REACT_APP_ADDRESS_ENHANCE_ITEM) {
            link = `${process.env.REACT_APP_BASE_URL_MARKET}/item-detail/${getNameItemV1(1, data?.id)?.id}/${data?.from}/${data?.orderId}/${data?.id}/Enhance_Item/1`;
          } else if (data?.address === process.env.REACT_APP_ADDRESS_FUSION_ITEM) {
            link = `${process.env.REACT_APP_BASE_URL_MARKET}/item-detail/${getNameItemV1(2, data?.id)?.id}/${data?.from}/${data?.orderId}/${data?.id}/Fusion_Item/1`;
          } else if (data?.address === process.env.REACT_APP_ADDRESS_REGENERATION_ITEM) {
            if (data?.name === 'Regeneration Hash [Random]') {
              link = `${process.env.REACT_APP_BASE_URL_MARKET}/item-detail/REGENERATION_HASH_RANDOM_R/${data?.from}/${data?.orderId}/${data?.id}/Regeneration_Hash/1`;
            } else if (data?.id >= 10000) {
              link = `${process.env.REACT_APP_BASE_URL_MARKET}/item-detail/REGENERATION_HASH_OOO_R/${data?.from}/${data?.orderId}/${data?.id}/Regeneration_Hash/1`;
            } else {
              link = `${process.env.REACT_APP_BASE_URL_MARKET}/item-detail/${getNameItemV1(3, data?.id)?.id}/${data?.from}/${data?.orderId}/${data?.id}/Regeneration_Hash/1`;
            }
          }
          return (
            <a
              style={{ color: '#40A9FF' }}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`#${data?.id}`}
            </a>
          )
        } else if (data?.address === process.env.REACT_APP_ADDRESS_CRYSTAL_ITEM) {
            link = `${process.env.REACT_APP_BASE_URL_MARKET}/item-detail/Enhance_Item_Crystal/${data?.from}/${data?.orderId}/${data?.id}/Enhance_Item_Crystal/1`;
            return (
              <a
                style={{ color: '#40A9FF' }}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`#${data?.id}`}
              </a>
            )
        } else {
          if (typeof data?.name === 'string') {
            if (data?.address === process.env.REACT_APP_ADDRESS_MONSTER) {
              link = `${process.env.REACT_APP_BASE_URL_MARKET}/monster/${data?.id}`;
            } else if (data?.address === process.env.REACT_APP_ADDRESS_FARM) {
              link = `${process.env.REACT_APP_BASE_URL_MARKET}/farm-detail/${data?.id}`
            }
          } else if (typeof data?.name === 'number') {
            link = `${process.env.REACT_APP_BASE_URL_MARKET}/hash-nft-detail/${data?.id}/${data?.address}/${data?.orderId}`;
          }
          return (
            <a
              style={{ color: '#40A9FF' }}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`#${data?.id}`}
            </a>
          )
        }
      },
    },
    {
      title: t('profile.tradeHistory.tokenName'),
      dataIndex: 'tokenID',
      align: 'center',
      key: 'tokenID',
      render: (data) => {
        if (is1155(data?.address)) {
          if (data?.name === 'Regeneration Hash [Random]') {
              return 'Random';
            } else if (data?.id >= 10000) {
              return data?.name
            } else {
              return getNameItemByContract(data?.address, data?.id)?.name || getNameItemV1(3, data?.id);
          }
        } else if (data?.address === process.env.REACT_APP_ADDRESS_CRYSTAL_ITEM) {
            return `${t('crystalItem', { item: data?.name })}`;
        }
        else {
          if (typeof data?.name === 'string') {
            return data.name;
          } else if (typeof data?.name === 'number') {
            return getSpeciesValue(data?.name, data?.extra)?.name;
          } else {
            return 'N/A';
          }
        }
      },
    },
    {
      title: t('profile.tradeHistory.quantity'),
      dataIndex: 'quantity',
      align: 'center',
      key: 'quantity',
      render: (data) => {
        return <div>{data}</div>
      },
    },
    {
      title: t('profile.tradeHistory.price'),
      dataIndex: 'price',
      align: 'center',
      key: 'price',
      render: (data) => {
        return (
          <div>
            {formatNumber(data)} OAS
          </div>
        )
      },
    },
    {
      title: (
        <>
          {t('profile.tradeHistory.time')} (UTC{' '}
          {userUtcOffset >= 0 ? `+${userUtcOffset}` : userUtcOffset})
        </>
      ),
      dataIndex: 'time',
      align: 'center',
      key: 'time',
      render: (data) => {
        return dayjs(data * 1000).format('YYYY-MM-DD HH:mm:ss')
      },
    },
    {
      title: t('profile.tradeHistory.from'),
      dataIndex: 'from',
      align: 'center',
      key: 'from',
      render: (data) => {
        let link = `${configs.NETWORK.scan}address/${data}`
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            style={{ color: '#40A9FF' }}
          >
            {convertAddressToProperFormat(formatAddress(data))}
          </a>
        )
      },
    },
    {
      title: t('profile.tradeHistory.to'),
      dataIndex: 'to',
      align: 'center',
      key: 'to',
      render: (data) => {
        let link = `${configs.NETWORK.scan}address/${data}`
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            style={{ color: '#40A9FF' }}
          >
            {convertAddressToProperFormat(formatAddress(data))}
          </a>
        )
      },
    },
    {
      title: t('profile.tradeHistory.txHash'),
      dataIndex: 'txHash',
      align: 'center',
      key: 'txHash',
      render: (data) => {
        const link = `${configs.NETWORK.scan}tx/${data}`
        return (
          <a
            style={{ color: '#40A9FF' }}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {formatTransaction(data)}
          </a>
        )
      },
    },
  ]

  const isMobile = useMediaQuery({ query: SCREEN_SIZE.TABLET })
  const [openFilterHistory, setOpenFilterHistory] = useState(false)

  const showDrawer = () => {
    setOpenFilterHistory(true)
  }

  const onClose = () => {
    setOpenFilterHistory(false)
  }

  const clearAll = () => {
    setEvent([])
    setAssetType([])
    setDate([null, null])
  }

  const handleToggleMyHistory = () => {
    setIsMyHistoryOnly(!isMyHistoryOnly)
  }

  return (
    <BodyCommon>
      <div className="profile__body container__common mx-auto p-[10px] !pt-6 relative top-[84px]">
        <Row className={`${isMobile ? '' : 'mx-auto h-[100vh] filter_profile'}`}>
        <Col xl={6} md={6} sm={24} xs={24} className="relative">
          {isMobile ? (
            <></>
          ) : (
            <div className="flex w-full h-full">
              <FilterHistory
                event={event}
                assetType={assetType}
                date={date}
                setEvent={setEvent}
                setAssetType={setAssetType}
                setDate={setDate}
                classCustom="filter__profile"
              />
            </div>
          )}
        </Col>
        <Col xl={18} md={18} sm={24} xs={24} className="relative">
          <div className="mx-auto z-10 pl-0 sm:pl-[15px] relative md:sticky top-0 sm:top-[104px] pb-12 pt-[1.5rem]">

            {isMobile ? (
              <div
                className="text-[24px] mb-4"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div className="mt-[10px]" style={{ flex: 2 }}>
                  {t('layout.header.tradeHistory')}
                </div>
                {user && (
                <div style={{ flex: 1, textAlign: 'right' }}>
                  <span style={{ marginRight: '1rem' }}>
                    {t('profile.menu.myHistoryOnly')}
                  </span>
                  <Switch
                    checked={isMyHistoryOnly}
                    onChange={handleToggleMyHistory}
                    disabled={!user}
                    checkedChildren="ON"
                    unCheckedChildren="OFF"
                  />
                  <Button
                    type="primary"
                    onClick={showDrawer}
                    className="flex justify-center items-center bg-[#0d2758] px-[10px] py-[16px] h-[44px] w-[100px] ml-[20px] mt-[10px]"
                  >
                    <FilterOutlined />
                    <span className="text-[13px] xl:text-[16px] md:text-[16px]">
                      {t('filter')}
                    </span>
                  </Button>
                  <Drawer
                    title={t('filter')}
                    width={330}
                    placement="left"
                    onClose={onClose}
                    open={openFilterHistory}
                    extra={
                      <div
                        className="text-[16px] text-[#FAAD14] cursor-pointer"
                        onClick={() => {
                          clearAll()
                        }}
                      >
                        {t('clearAll')}
                      </div>
                    }
                  >
                    <div className="flex w-full h-full">
                      <FilterHistory
                        event={event}
                        assetType={assetType}
                        date={date}
                        setEvent={setEvent}
                        setAssetType={setAssetType}
                        setDate={setDate}
                        classCustom="filter__profile"
                      />
                    </div>
                  </Drawer>
                </div>
                )}
              </div>
            ) : (
              <div
                className="text-[24px] mb-4"
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div>{t('layout.header.tradeHistory')}</div>
                {user && (
                <div>
                  <span style={{ marginRight: '1rem', fontSize: '14px'  }}>{t('profile.menu.myHistoryOnly')}</span>
                  <Switch
                    checked={isMyHistoryOnly}
                    onChange={handleToggleMyHistory}
                    checkedChildren="ON"
                    unCheckedChildren="OFF"
                    style={{ transform: 'scale(0.9)', marginTop: '3.8px' }}
                  />
                </div>
                )}
              </div>
            )}

            <Datatable
              scroll={{ x: 1300 }}
              columns={columns}
              dataSource={dataHistories}
              loading={isLoading}
              metadata={{
                perPage: pageSize,
                setPerPage: setPageSize,
                page,
                setPage,
                total: totalData === 0 ? 1 : totalData,
              }}
              showPagination={true}
            />
          </div>
        </Col>
      </Row>
      </div>
    </BodyCommon>
  )
}

export default TradeHistory